export enum NotAvailableBackgroundType {
  performanceMetricsBackground,
  verticalBenchmarkBackground,
}

export function NotAvailableBackground({ type }: { type: NotAvailableBackgroundType }) {
  return (
    <div className="relative px-[25px] pt-5">
      {type === NotAvailableBackgroundType.performanceMetricsBackground ? (
        <div className="flex h-[600px] w-full select-none items-end justify-end bg-[url('/assets/vertical-benchmark-background.jpg')] bg-cover bg-right blur-md" />
      ) : null}
      {type === NotAvailableBackgroundType.verticalBenchmarkBackground ? (
        <div className="flex h-[600px] w-full select-none items-end justify-end bg-[url('/assets/performance-metrics-background.jpg')] bg-cover bg-right blur-md" />
      ) : null}
    </div>
  );
}
